import Vue from "vue";
import router from "~/routes.js";
import constans from "~/constans.js";
import { store } from "~/store/index.js";
import moment from "moment-jalaali";
moment.loadPersian({ dialect: "persian-modern" });

import lib from "~/assets/js/enc_player/lib.js";
import hls from "~/assets/js/enc_player/hls.js@latest.js";
import { initApp } from "~/assets/js/enc_player/code.js";

export default {
  filters: {
    currency: function(val) {
      if (val) {
        return (
          parseInt(val)
            .toFixed(0)
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") + " ریال"
        );
      } else {
        return 0;
      }
    },
    date(value) {
      if (!value) return "";
      return moment(value).format("jD jMMMM jYYYY");
    },
    truncate: function(text, count) {
      if (!text) return "";
      return text.slice(0, count) + (text.length > count ? "..." : "");
    },
    level: function(val) {
      if (!val) return "";
      if (val === 1 || val === "1") {
        return "مقدماتی";
      } else if (val === 2 || val === "2") {
        return "متوسط";
      } else if (val === 3 || val === "3") {
        return "پیشرفته";
      } else if (val === 4 || val === "4") {
        return "صفر تا 100";
      }
    }
  },
  computed: {
    configMedia: () => ({
      menubar: false,
      link_assume_external_targets: true,
      toolbar: [
        "undo redo | bold italic | link | alignleft aligncenter alignright alignjustify | image media"
      ],
      plugins: ["link  image media imagetools"],
      file_picker_types: "image",
      language: "fa_IR",
      height: 300,
      language_url:
        "https://admin.salameno.ir/static/libs/tinymce/langs/fa_IR.js",
      directionality: "rtl",
      // eslint-disable-next-line no-unused-vars
      file_picker_callback: function(cb, value, meta) {
        var input = document.createElement("input")
        input.setAttribute("type", "file")
        input.setAttribute("accept", "image/*")

        // Note: In modern browsers input[type="file"] is functional without
        // even adding it to the DOM, but that might not be the case in some older
        // or quirky browsers like IE, so you might want to add it to the DOM
        // just in case, and visually hide it. And do not forget do remove it
        // once you do not need it anymore.

        input.onchange = function() {
          var file = this.files[0]

          var reader = new FileReader()
          reader.onload = function() {
            // Note: Now we need to register the blob in TinyMCEs image blob
            // registry. In the next release this part hopefully won't be
            // necessary, as we are looking to handle it internally.
            var id = "blobid" + new Date().getTime()
            var blobCache = tinymce.activeEditor.editorUpload.blobCache
            var base64 = reader.result.split(",")[1]
            var blobInfo = blobCache.create(id, file, base64)
            blobCache.add(blobInfo)

            // call the callback and populate the Title field with the file name
            cb(blobInfo.blobUri(), { title: file.name })
          }
          reader.readAsDataURL(file)
        }
        input.click()
      }
    }),
    configBase: () => ({
      menubar: false,
      toolbar: [
        "undo redo | bold italic | link | alignleft aligncenter alignright alignjustify"
      ],
      link_assume_external_targets: true,
      plugins: ["link"],
      file_picker_types: "image",
      language: "fa_IR",
      height: 300,
      language_url:
        "https://admin.salameno.ir/static/libs/tinymce/langs/fa_IR.js",
      directionality: "rtl",
      // eslint-disable-next-line no-unused-vars
      file_picker_callback: function(cb, value, meta) {
        var input = document.createElement("input")
        input.setAttribute("type", "file")
        input.setAttribute("accept", "image/*")

        // Note: In modern browsers input[type="file"] is functional without
        // even adding it to the DOM, but that might not be the case in some older
        // or quirky browsers like IE, so you might want to add it to the DOM
        // just in case, and visually hide it. And do not forget do remove it
        // once you do not need it anymore.

        input.onchange = function() {
          var file = this.files[0]

          var reader = new FileReader()
          reader.onload = function() {
            // Note: Now we need to register the blob in TinyMCEs image blob
            // registry. In the next release this part hopefully won't be
            // necessary, as we are looking to handle it internally.
            var id = "blobid" + new Date().getTime()
            var blobCache = tinymce.activeEditor.editorUpload.blobCache
            var base64 = reader.result.split(",")[1]
            var blobInfo = blobCache.create(id, file, base64)
            blobCache.add(blobInfo)

            // call the callback and populate the Title field with the file name
            cb(blobInfo.blobUri(), { title: file.name })
          }
          reader.readAsDataURL(file)
        }
        input.click()
      }
    }),
    editorOption() {
      return {height: "300px",
      modules: {
        toolbar: [
          ["bold", "italic"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image", "video"]
        ],
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false
        },
        imageDrop: true,
        imageResize: {
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white"
          },
          modules: ["Resize", "DisplaySize", "Toolbar"]
        }
      }}
    },
    imageUser() {
      return require("../../static/img/avatar.png");
    },
    linkCourses() {
      return (
        "/courses/" +
        this.$route.params.en_category +
        "/" +
        this.$route.params.en_subcategory +
        "/" +
        this.$route.params.id +
        "/" +
        this.$route.params.course_title_encourses
      );
    },
    appUrl() {
      return constans.url;
    },
    isLogin() {
      return this.$store.state.auth.isLogin;
    },
    user() {
      return this.$store.state.auth.user;
    },
    openVideoModal() {
      return this.$store.state.video.show;
    },
    patch(){
     return this.$route.fullPath
    }
  },
  methods: {
    splitString(text, count) {
      return text.slice(0, count) + (text.length > count ? "..." : "");
    },
    onEditorReady(editor) {
      editor.format("direction", "rtl");
      editor.format("align", "right");
    },
    async addBasketCart(item) {
      if (!this.isLogin) {
        this.$store.commit("auth/setRedirect", false);
        this.showModalLogin();
        return;
      }
      let { data } = await axios.post("/enroll/check", { course_id: item.id });
      if (data.enroll) {
        this.$root.showWarnMsg({
          message: "شما مخاطب دوره هستید ... "
        });
        return;
      }
      if (data.state != 200) return;
      let listShopp = {
        price: item.course_price,
        id: item.id,
        name: item.course_title,
        title: item.course_title_en,
        en_category: item.en_category,
        en_subcategory: item.en_subcategory
      };
      if (!localStorage.getItem("shoppingCard")) {
        localStorage.setItem("shoppingCard", JSON.stringify([listShopp]));
      } else {
        var arr = JSON.parse(localStorage.getItem("shoppingCard"));
        arr.push(listShopp);
        let arrNoDup = this.removeDuplicates(arr, "id");
        localStorage.setItem("shoppingCard", JSON.stringify(arrNoDup));
      }
      let lengths = JSON.parse(localStorage.shoppingCard).length;
      this.$store.commit("basket/SET_DATA", {
        data: lengths,
        id: "lenghtBasketCard"
      });

      this.$store.commit("basket/SET_DATA", {
        data: JSON.parse(localStorage.getItem("shoppingCard")),
        id: "basketList"
      });
    },
    milady(date) {
      return moment(date, "jYYYY/jM/jD").format("YYYY-M-D");
    },
    shamsi(date) {
      if (!date) return "";
      return moment(date).format("jYYYY/jM/jD");
    },
    async checkInstructor() {
      try {
        let { data } = await axios.post("/become-instructor/check");
        if (data.state !== 200) return false;
        this.$store.commit('dashboardProfile/SET_DATA',{data:data.url,id:'url'})
        return data["is-instrustor"];
      } catch (error) {
        console.log(error);
      }
    },

    async playVideoEnc(src) {
      await this.$store.dispatch("video/toggleShow", {
        value: true
      });
      initApp(src, this.openVideoModal);
    },
    playVideo(src) {
      this.$store.dispatch("video/toggleShow", {
        value: true,
        src: this.appUrl.media + "/" + src
      });
    },
    removeCourseId() {
      sessionStorage.removeItem("course_id");
    },
    hasCourse() {
      if (sessionStorage.length) {
        return {
          is: !!sessionStorage.getItem("course_id"),
          id: parseInt(sessionStorage.getItem("course_id"))
        };
      } else {
        return false;
      }
    },
    async checkAccess(isAlert) {
      this.isLoading = true;
      try {
        let { data } = await axios.post("/become-instructor/check");
        if (data.state !== 200) return;
        if (!data["is-instrustor"]) {
          if (isAlert) {
            this.$store.commit("notifications/error", {
              message: "درخواست شما در حال بررسی می باشد.",
              title: "تایید درخواست"
            });
          }
        }
        return data["is-instrustor"];
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    showModalLogin() {
      this.$store.dispatch("auth/showModalLogin", true);
    },
    formHandeler(value) {
      let keysValue = {};
      for (let index = 0; index < value.length; index++) {
        const element = value[index];
        if (element.name) {
          keysValue[element.name] =
            typeof element.model !== "undefined" ? element.model : "";
        }
      }
      return keysValue;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/global.js